<script>
import ServiceACL from '../../../../domain/acl/services/acl'
import service from '../../../../domain/usuarios/services'

export default {
  name: 'ConfiguracaoUsuarioAcl',
  props: {
    acls: {
      type: Object,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      listaACL: [],
      aclOptions: [
        {label: 'Ativada', value: true, class: 'btn-default'},
        {label: 'Desativada', value: false, class: 'btn-default'}
      ]
    }
  },
  mounted () {
    this.loadACL()
  },
  methods: {
    loadACL () {
      const {acl = {}} = (this.acls || {})
      const usuarioACLs = Object.values(acl)
      ServiceACL.list()
        .then(response => {
          this.listaACL = (response.data || []).map(item => {
            item.ativado = false
            if (usuarioACLs.length) {
              item.ativado = usuarioACLs.indexOf(item.codigo) !== -1
            }
            return item
          })
        })
        .catch((error) => {
          alert('Ocorreu um erro ao carregar as ACLs')
          console.log(error)
        })
    },
    atualizarACL (index) {
      const acl = this.listaACL[index]
      const tmp = {true: 'ativar', false: 'remover'}
      const confirmado = confirm(`Confirmar ${tmp[acl.ativado]} ACL "${acl.nome}"?`)
      if (!confirmado) {
        acl.ativado = !acl.ativado
        return
      }
      service.adicionarACL(this.$route.params.id, acl.id, acl.ativado)
        .then((response) => {
          console.log(response)
        })
        .catch((response) => {
          window.alert(`Não foi possível adicionar a acl "${acl.nome}", algum problema ocorreu, tente novamente.`)
          acl.ativado = !acl.ativado
          console.log(response)
        })
    }
  }
}
</script>

<template>
  <div class="panel panel-default">
    <div class="table-responsive" style="overflow-y: auto; overflow-x: unset">
      <table class="table table-hover table-striped b-t b-light">
        <thead>
        <tr>
          <th>ACL</th>
          <th>Descrição</th>
          <th style="min-width: 200px">Ação</th>
        </tr>
        </thead>
        <tbody>
        <!-- FAKE -->
        <tr v-if="!listaACL.length" v-for="i in [1,2,3]">
          <td class="v-middle">
            <u-fake-loader width="20px" class="m-t"></u-fake-loader>
          </td>
          <td role="button" tabindex="0">
            <u-fake-loader width="40%" class="m-t"></u-fake-loader>
          </td>
          <td role="button" tabindex="0">
            <a class="text-cap custom-link ">
              <u-fake-loader width="100%" class="m-t"></u-fake-loader>
            </a>
          </td>
        </tr>
        <tr v-for="(data, index) in listaACL">
          <td role="button" tabindex="0">
            {{data.nome}}
          </td>
          <td role="button" tabindex="0">
            {{data.descricao}}
          </td>
          <td role="button" tabindex="0">
            <u-button-group
              @change="atualizarACL(index)"
              class="hidden-print"
              v-model="data.ativado"
              :options="aclOptions"
            >
            </u-button-group>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// ConfiguracaoUsuarioACL.vue?4935fff8